import { memo, useRef, useState } from 'react';
import ButtonIconGhostSmall from '../../../../components/common/ButtonIconGhost/ButtonIconGhostSmall';
import { Icon } from '../../../../components/icon/icon.jsx';
import './CardMaterial.scss';
import ButtonTertiarySmall from '../../../../components/common/ButtonTertiary/ButtonTertiarySmall';
import ButtonTertiaryMedium from '../../../../components/common/ButtonTertiary/ButtonTertiaryMedium';
import { Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import { cn } from '../../../../utils/string/cn.utils';
import { Popover } from 'antd';
import { Navigation, A11y } from 'swiper/modules';

import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import ButtonIconOutlineSmall from '../../../../components/common/ButtonIconOutline/ButtonIconOutlineSmall';
import ButtonLink from '../../../../components/common/ButtonLink/ButtonLink.jsx';
import { getValueFromString } from '../../../../utils/data/getValue.utils.js';

const CardMaterial = memo(({ item, active, onClick, hideOption = false }) => {
  const { src, title, color, description, detailLink, productDemo } = item;
  const [loading, setLoading] = useState(false);
  // const [isHover, setIsHover] = useState(false);
  const { t } = useTranslation();

  return (
    <>
      <div
        className={cn(
          'card-material flex flex-col items-start rounded-[4px] bg-fills-white border-[2px] border-solid border-transparent hover:border-outline-brand-primary',
          active ? 'border-outline-brand-primary' : '',
          hideOption ? 'cursor-pointer' : ''
        )}
        // onMouseOver={(e) => setIsHover(true)}
        // onMouseLeave={(e) => setIsHover(false)}
        onClick={async () => {
          if (hideOption) {
            setLoading(true);
            await onClick(() => setLoading(false));
          }
        }}
        style={{
          opacity: loading ? 0.7 : 1,
          position: 'relative',
          pointerEvents: loading ? 'none' : 'all',
        }}
      >
        <div className="card-material-img flex justify-center items-center gap-8 self-stretch p-6 overflow-hidden relative rounded-[2px]">
          {src ? (
            <img
              className="object-fit-cover rounded-[2px] self-stretch border-[1px] border-solid border-[#F4F4F4]"
              src={src}
              alt=""
              loading="lazy"
              decoding="async"
              style={{ willChange: 'transform' }}
            />
          ) : (
            <div
              className="color rounded-[2px] border-[1px] border-solid border-[#F4F4F4]"
              style={{ backgroundColor: color }}
            ></div>
          )}
          {loading && (
            <div
              style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                background: 'rgba(255,255,255,0.9)',
                padding: '5px 10px',
                borderRadius: '4px',
                color: '#007bff',
                fontSize: '12px',
                fontWeight: 'bold',
              }}
            >
              Loading...
            </div>
          )}
        </div>
        <div className="flex p-4 flex-col items-center gap-4 self-stetch w-full">
          <div className="card-material-info-field flex items-center gap-6 self-stretch justify-between">
            <span className="text-body-medium-emphasized font-semibold truncate text-black-high">
              {getValueFromString(title)}
            </span>
            {/* <ButtonIconGhostSmall
            icon={<Icon.ICInfoFill />}
            style={{ color: "#258FD2" }}
          /> */}
          </div>
          <div className="card-material-info-field flex items-center gap-6 self-stretch ">
            <span className="text-body-small truncate text-black-medium">
              {getValueFromString(description)}
            </span>
          </div>
        </div>
        {!hideOption && (
          <>
            <div
              className="extend-action gap-8 absolute left-0 right-0 items-center justify-center flex flex-col top-0 bottom-0 z-index-1"
              style={{ backgroundColor: 'rgba(0, 0, 0, 0.16)' }}
            >
              {/* {isHover ? (
                <Tooltip
                  title={title}
                  getPopupContainer={() => document.body}
                  destroyOnHidden
                  open
                  placement="top">
                  <div
                    className="flex gap-8 absolute left-0 right-0 items-center justify-center flex flex-col top-0 bottom-0"
                    style={{ zIndex: -1 }}></div>
                </Tooltip>
              ) : (
                <></>
              )} */}
              <ButtonTertiarySmall
                posIcon={<Icon.ICCheck />}
                title={
                  <span className="text-label-small">
                    {t('Only this cabinet')}
                  </span>
                }
                className={'rounded-[100px] bg-fills-white text-black-medium'}
                onClick={async () => {
                  setLoading(true);
                  await onClick(() => setLoading(false));
                }}
              />
              <ButtonTertiarySmall
                posIcon={<Icon.ICSelectAll />}
                title={
                  <span className="text-label-small">{t('Apply to all')}</span>
                }
                className={'rounded-[100px] bg-fills-white text-black-medium'}
                onClick={async () => {
                  setLoading(true);
                  await onClick(() => setLoading(false), true);
                }}
              />
              {productDemo?.length ? (
                <RenderPopover item={item}>
                  <span>
                    <ButtonTertiarySmall
                      posIcon={<Icon.ICInfoFill />}
                      title={
                        <span className="text-label-small">
                          {t('View information')}
                        </span>
                      }
                      className={
                        'rounded-[100px] bg-fills-white text-black-medium'
                      }
                    />
                  </span>
                </RenderPopover>
              ) : null}
            </div>
          </>
        )}
      </div>
    </>
  );
});

export default CardMaterial;

const RenderPopover = ({ children, item }) => {
  const { t } = useTranslation();
  const swiperRef = useRef(null);
  const [swiperInfo, setSwiperInfo] = useState({});

  const updateSwiperInfo = swiper => {
    setSwiperInfo({
      ...swiper,
    });
  };

  return (
    <Popover
      trigger={'click'}
      content={
        <section className="flex flex-col items-start gap-[12px]">
          <div className="w-[400px] h-[400px] flex rounded-[8px] overflow-hidden">
            <Swiper
              id={item.id}
              ref={swiperRef}
              modules={[Navigation, A11y]}
              spaceBetween={50}
              slidesPerView={1}
              navigation={{
                prevEl: '.card-material-swiper-button-prev' + item.id,
                nextEl: '.card-material-swiper-button-next' + item.id,
              }}
              onSwiper={swiper => {
                updateSwiperInfo(swiper);
              }}
              onSlideChange={swiper => {
                updateSwiperInfo(swiper);
              }}
              onResize={swiper => {
                updateSwiperInfo(swiper);
              }}
            >
              {item?.productDemo?.map((item, index) => (
                <SwiperSlide key={index}>
                  <div className="w-[400px] h-[400px] flex rounded-[8px] overflow-hidden">
                    <img
                      src={item}
                      alt=""
                      className="object-cover aspect-square"
                    />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
          <div className="custom-navigation flex justify-center items-center gap-[24px] self-stretch">
            <ButtonIconOutlineSmall
              icon={<Icon.ICArrowBack />}
              className={'card-material-swiper-button-prev' + item.id}
            />
            <span className="text-body-medium">
              {swiperInfo.activeIndex + 1} / {item?.productDemo?.length}
            </span>
            <ButtonIconOutlineSmall
              icon={<Icon.ICArrowForward />}
              className={'card-material-swiper-button-next' + item.id}
            />
          </div>
          <div className="flex items-center gap-[4px] self-stretch">
            <div className="flex items-center gap-[8px] grow">
              <span className="text-body-large font-semibold text-black-medium">
                {item.title}
              </span>
            </div>
            <div className="text-body-medium text-black-medium">
              *Ảnh thực tế
            </div>
          </div>
          <ButtonLink
            title={t('Xem ảnh từ')}
            disabled={item.detailLink}
            icon={<Icon.ICOpenNewTab />}
            className={'text-Accents-Blue'}
            onClick={() => {
              window.open(detailLink, '_blank');
            }}
          />
        </section>
      }
      placement="left"
      arrow={false}
      classNames={{
        body: '!p-[16px] items-start !gap-[12px] !rounded-[16px]',
      }}
      getPopupContainer={() => document.body}
    >
      {children}
    </Popover>
  );
};
